import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 14692438-9215-4003-AF95-04AA7C27DA48
 * name calendar-export
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-export.svg
 * tags
 * - Date / Time 
 */
export const CalendarExportIcon = createSvgIcon(<><path d="M12 22L16 18H13V12H11V18H8L12 22M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H8L6 19H5V8H19V19H18L16 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3Z" /></>, 'CalendarExportIcon');
export default CalendarExportIcon